import React from 'react';

const Trash = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.11312 15.5951C2.16551 16.1714 2.63703 16.5905 3.21334 16.5905H12.2596C12.8359 16.5905 13.3074 16.1539 13.3598 15.5951L14.3727 4.97711H1.10022L2.11312 15.5951ZM9.95436 8.29523C9.95436 7.99835 10.1988 7.73639 10.5132 7.73639C10.8101 7.73639 11.072 7.98088 11.072 8.29523V13.2724C11.072 13.5693 10.8275 13.8312 10.5132 13.8312C10.2163 13.8312 9.95436 13.5868 9.95436 13.2724V8.29523ZM7.17762 8.29523C7.17762 7.99835 7.42211 7.73639 7.73646 7.73639C8.03334 7.73639 8.2953 7.98088 8.2953 8.29523V13.2724C8.2953 13.5693 8.0508 13.8312 7.73646 13.8312C7.43957 13.8312 7.17762 13.5868 7.17762 13.2724V8.29523ZM4.41834 8.29523C4.41834 7.99835 4.66283 7.73639 4.97718 7.73639C5.27406 7.73639 5.53602 7.98088 5.53602 8.29523V13.2724C5.53602 13.5693 5.29153 13.8312 4.97718 13.8312C4.68029 13.8312 4.41834 13.5868 4.41834 13.2724V8.29523Z"
      fill="#787F88"
    />
    <path
      d="M14.3727 1.65906H9.95436V1.10022C9.95436 0.488986 9.46537 0 8.85414 0H6.63624C6.025 0 5.53602 0.488986 5.53602 1.10022V1.65906H1.10022C0.488986 1.65906 0 2.14804 0 2.75928C0 3.37051 0.488986 3.8595 1.10022 3.8595H14.3727C14.9839 3.8595 15.4729 3.37051 15.4729 2.75928C15.4729 2.14804 14.9839 1.65906 14.3727 1.65906Z"
      fill="#787F88"
    />
  </svg>
);

export default Trash;
